const rawWinners = [
  [2026, "Bay Nalçakan", "Halis Karataş", "Emrah Nalçakan", "2.29.49", "https://www.youtube.com/watch?v=-fN5g5OL8TM"],
  [2025, "Cutha", "Ahmet Çelik", "Hulusi Çil", "2.30.28", "https://www.youtube.com/watch?v=NbBP4JPgsvU"],
  [2024, "Dragon Flame", "Akın Sözen", "Emrah Agun", "2.28.36", "https://www.youtube.com/watch?v=wnviTqkZApM"],
  [2023, "Urfa Aslanı", "Mehmet Kaya", "Selim Kaya", "2.30.35", "https://www.youtube.com/watch?v=wKthBpEIRP4"],
  [2022, "Secret Power", "Özcan Yıldırım", "Emrah Karamazı", "2.31.04", "https://www.youtube.com/watch?v=8l0rFqUPRHE"],
  [2021, "Burgas", "Ahmet Çelik", "Sanem Kahraman", "2.27.36", "https://www.youtube.com/watch?v=9G7pi_YrM7U"],
  [2020, "Call To Victory", "Ahmet Çelik", "Ayşegül Kurtel", "2.30.18", "https://www.youtube.com/watch?v=dbbtV48trDg"],
  [2019, "The Last Romance", "Ahmet Çelik", "Melis Kurtel Emin", "2.27.73", "https://www.youtube.com/watch?v=PmzeIqENmDI"],
  [2018, "Hep Beraber", "Ahmet Çelik", "Veysel Kahraman", "2.29.67", "https://www.youtube.com/watch?v=I42uGAN2qK0"],
  [2017, "Piano Sonata", "Ahmet Çelik", "Oğuz Yalçın", "2.27.74", "https://www.youtube.com/watch?v=emA3dcvPxyM"],
  [2016, "Graystorm", "Ahmet Çelik", "Ahmet Güzelocak", "2.30.50", "https://www.youtube.com/watch?v=p6rsEarVBOg"],
  [2015, "Renk", "Ahmet Çelik", "Gülçin Kundakçı", "2.30.82", "https://www.youtube.com/watch?v=0VEn4m6KDTs"],
  [2014, "Blaze To Win", "Halis Karataş", "Levent N. Gelgin", "2.35.04", "https://www.youtube.com/watch?v=j3G_lWX8MeM"],
  [2013, "Divine Heart", "Yücel Bilik", "Atila Özkan", "2.31.09", "https://www.youtube.com/watch?v=agPyzXOUh34"],
  [2012, "Matador Yaşar", "Halis Karataş", "Ahmet Göçmen", "2.30.73", "https://www.youtube.com/watch?v=MBYOgU1M034"],
  [2011, "Anatoly", "Halis Karataş", "Osman Hattat", "2.27.83", "https://www.youtube.com/watch?v=80bABa-4_F8"],
  [2010, "Mystical Storm", "Selim Kaya", "Can Şemenoğlu", "2.29.80", "https://www.youtube.com/watch?v=vaok3613eVs"],
  [2009, "Miramis", "Gökhan Kocakaya", "Ahmet Kılıçcıoğlu", "2.30.33", "https://www.youtube.com/watch?v=6VdJTkAgvCo"],
  [2008, "Pan River", "Sadettin Boyraz", "Nevzat Seyok", "2.28.03", "https://www.youtube.com/watch?v=GqmYYFWCFh8"],
  [2007, "Inspector", "Ömer Kaya", "Hayrullah Doğan", "2.30.20", "https://www.youtube.com/watch?v=98C8lFKURYs"],
  [2006, "Hızel Beyi", "Halis Karataş", "Kadri Daşkan", "2.27.60", "https://www.youtube.com/watch?v=-ku4SbUxLJ4"],
  [2005, "Popular Demand", "Halis Karataş", "Gülsüm Eliyeşil", "2.29.43", "https://www.youtube.com/watch?v=CBDy-XoAR-I"],
  [2004, "Yavuzstar", "Arslan Birdal", "Müthiş Ölçer", "2.27.23", "https://www.youtube.com/watch?v=TuaKErC_Q0o"],
  [2003, "Sufi", "Bekir Gökçe", "Fikret Ceylan", "2.28.32", "https://www.youtube.com/watch?v=n8yw6ZpuLn0"],
  [2002, "Fernando", "Fuat Çakar", "S. Selman Taşbek", "2.30.12", "https://www.youtube.com/watch?v=Yy8nkRGaS4Q"],
  [2001, "Grand Ekinoks", "Yalçın Akağaç", "Volkan R. Ekinci", "2.28.86", "https://www.youtube.com/watch?v=e5iThpGs-08"],
  [2000, "Caprice", "Sadettin Boyraz", "İsmail H. Tiritoğlu", "2.26.71", "https://www.youtube.com/watch?v=NOmxt2K1RcY"],
  [1999, "Bartrobel", "Ertül Cankılıç", "Mehmet Kurt", "2.30.96", "https://www.youtube.com/watch?v=Hh2Yqkcz_ek"],
  [1998, "Kavranhan", "Fuat Çakar", "Ahmet Kavran", "2.27.96", "https://www.youtube.com/watch?v=k4qpBGlKY8I"],
  [1997, "Fair Tail", "Akın Özdeniz", "M. Kaya Erkkul", "2.28.99", "https://www.youtube.com/watch?v=9nP9BU9ewWk"],
  [1996, "Bold Pilot", "Halis Karataş", "Özdemir Atman", "2.26.22", "https://www.youtube.com/watch?v=UCM0Z3UVIwE"],
  [1995, "Welldone", "Ahmet Atçı", "Aysel Birol", "2.28.69", "https://www.youtube.com/watch?v=1NziF_NuWgw"],
  [1994, "As Jet", "Tınay Adışen", "Sedat Özcan", "2.28.96", "https://www.youtube.com/watch?v=rMMW5aLvnoU"],
  [1993, "The Best", "Ertül Cankılıç", "Mehmet Kurt", "2.28.06", "https://www.youtube.com/watch?v=lMcLXkFWlKI"],
  [1992, "Prestige", "Süleyman Akdı", "Sedat Özcan", "2.28.06", "https://www.youtube.com/watch?v=8g6KoQpUQ1k"],
  [1991, "Abbas", "Mümin Çılgın", "Özdemir Atman", "2.29.82", "https://www.youtube.com/watch?v=IkNDK3yIKJQ"],
  [1990, "George Thomas", "Ertül Cankılıç", "Muammer Kitapçı", "2.26.96", "https://www.youtube.com/watch?v=PjNktg1z6ho"],
  [1989, "Golden Prince", "Ertül Cankılıç", "T. Seçkin Kapani", "2.27.18", "https://www.youtube.com/watch?v=PuWPX41hOq4"],
  [1988, "Top Image", "Mümin Çılgın", "Muammer Kitapçı", "2.28.02", "https://www.youtube.com/watch?v=cOxIB6ambZY"],
  [1987, "Mehter I", "Nedim Kandur", "Ganime Karabucak", "2.30.45", "https://www.youtube.com/watch?v=7IaLyOCmoaA"],
  [1986, "Hafız", "Mümin Çılgın", "Sadık Eliyeşil", "2.28.90", "https://www.youtube.com/watch?v=o8HjQFNZdwM"],
  [1985, "Uğurtay", "Mümin Çılgın", "Yavuz Sarıkaya", "2.30.53", "https://www.youtube.com/watch?v=TDTxEL7wEbc"],
  [1984, "Cartegena", "Ekrem Kurt", "Sadık Eliyeşil", "2.28.26", "https://www.youtube.com/watch?v=6rJ45mSOuAo"],
  [1983, "Seren I", "Kazım Yıldız", "Fahriye Esmer", "2.30.57", "https://www.youtube.com/watch?v=cSFulPBKz18"],
  [1982, "Toraman", "Ekrem Kurt", "Sadık Eliyeşil", "2.28.53", "https://www.youtube.com/watch?v=-QOr7tfuRtk"],
  [1981, "Dersim", "Mümin Çılgın", "A. Cemal Kura", "2.28.90", "https://www.youtube.com/watch?v=2x4vNGprQ88"],
  [1980, "Levano", "Kadir Altınöz", "Vural Çakım", "2.28.64", "https://www.youtube.com/watch?v=qWGBRZBy6r0"],
  [1979, "Doktor Seferof", "Mümin Çılgın", "A. Cemal Kura", "2.30.29", "https://www.youtube.com/watch?v=1poYbkbHyV8"],
  [1978, "Cihangir Harmony", "Süleyman Akdı", "Halim Celaloğlu", "2.31.25", "https://www.youtube.com/watch?v=ZC-d5U5TuNQ"],
  [1977, "Vidar", "Kadir Altınöz", "Hikmet Birol", "2.29.44", "https://www.youtube.com/watch?v=1bEwDb1vzoI"],
  [1976, "Buğra", "Ekrem Kurt", "Gülsüm Eliyeşil", "2.30.38", "—"],
  [1975, "Mayide", "Kazım Yıldız", "Z. Zihni Oğuz", "2.30.90", "—"],
  [1974, "Nadas", "Mümin Çılgın", "Sedat Üründül", "2.29.90", "—"],
  [1973, "Karayel", "Ekrem Kurt", "Sadık Eliyeşil", "2.34.00", "—"],
  [1972, "Akkor", "Ekrem Kurt", "Gülsüm Eliyeşil", "2.32.18", "—"],
  [1971, "Minimo", "Ekrem Kurt", "Gülsüm Eliyeşil", "2.33.00", "—"],
  [1970, "Sadettin", "Kazım Yıldız", "Sadrettin Atığ", "2.29.25", "https://www.youtube.com/watch?v=R9NSrR0isfQ"],
  [1969, "Palet", "Sedat Okumuş", "A. Cemal Kura", "2.29.78", "—"],
  [1968, "Asuvan", "Sedat Okumuş", "Burhan Karamehmet", "2.35.10", "—"],
  [1967, "Selten", "Kazım Yıldız", "Ali Rıza Ongun", "2.32.50", "—"],
  [1966, "Pikehan", "Yaşar Atçı", "Mustafa Dinkçioğlu", "2.32.50", "—"],
  [1965, "Apaçi", "Mümin Çılgın", "Fikret Yüzatlı", "2.33.00", "https://www.youtube.com/watch?v=hj12DgGLuAk"],
  [1964, "Kayarlı", "Yaşar Atçı", "Şadi Eliyeşil", "2.40.00", "—"],
  [1963, "Melikşah", "Mehmet Emin Özdekli", "Şadi Eliyeşil", "2.30.50", "—"],
  [1962, "Flying Star", "Kazım Yıldız", "Zühtü Erişen", "2.34.00", "—"],
  [1961, "Atlıhan", "J. C. Majerus", "Şadi Eliyeşil", "2.33.00", "—"],
  [1960, "Helene de Troia", "Mümin Çılgın", "William Giraud", "2.32.00", "—"],
  [1959, "Beau Manoir", "Kazım Yıldız", "William Giraud", "2.31.00", "—"],
  [1958, "Icaros", "Kazım Yıldız", "William Giraud", "2.41.00", "—"],
  [1957, "Mirage", "Reşat Mergin", "Mustafa Karabucak", "2.38.00", "—"],
  [1956, "La Fleche", "İsmail Dinçer", "William Giraud", "2.40.00", "—"],
  [1955, "Bikini", "Ekrem Kurt", "Fehmi Simsaroğlu", "2.30.00", "—"],
  [1954, "Beau Brummel", "Reşat Mergin", "William Giraud", "2.39.00", "—"],
  [1953, "Kusun", "Ahmet Uslu", "Şadi Eliyeşil", "2.33.50", "—"],
  [1952, "Virago", "Bahri Eröçbe", "Özdemir Atman", "2.34.00", "—"],
  [1951, "Etoile D’Argent", "N. Horvath", "William Giraud", "2.34.00", "https://www.youtube.com/watch?v=BMTlaTXHkD0"],
  [1950, "Darling", "Ahmet Uslu", "Şadi Eliyeşil", "2.36.00", "—"],
  [1949, "Corsaire", "N. Horvath", "William Giraud", "2.35.00", "—"],
  [1948, "Neslihan", "Reşat Mergin", "Mustafa Karamehmet", "2.41.00", "—"],
  [1947, "Adalı", "Bahri Eröçbe", "Nuri Midillili", "2.36.00", "—"],
  [1946, "Mine", "Z. Temizsoy", "Nuri Oğlakçı", "2.40.00", "—"],
  [1945, "Fettan", "Ş. Sokolay", "Ahmet Atman", "2.43.00", "—"],
  [1944, "Toros", "Davut Akdı", "İlhami Aytaç", "2.43.00", "—"],
  [1943, "Varad", "Ahmet Uslu", "Fikret Yüzatlı", "2.39.00", "—"],
  [1942, "Çobankızı", "N. Horvath", "Salih Temel", "2.44.00", "—"],
  [1941, "Sabutay", "Bayram Palaska", "Salih Temel", "2.40.00", "—"],
  [1940, "Konca", "A. Philips", "Ahmet Atman", "2.45.00", "—"],
  [1939, "Yılmazkaya", "Z. Kızılkaya", "M. Yılmaz", "2.46.00", "—"],
  [1938, "Romance", "N. Horvath", "Halim Sait", "2.44.50", "—"],
  [1937, "Taşpınar", "Davut Akdı", "Salih Temel", "—", "—"],
  [1936, "Şilem", "Paul", "Memduh Alan", "2.47.00", "—"],
  [1935, "Tomru", "N. Horvath", "Ahmet Atman", "—", "—"],
  [1934, "Ece", "Paul", "Salih Temel", "—", "—"],
  [1933, "Özdemir", "Yunus", "Karacabey Harası", "—", "—"],
  [1932, "Lale", "N. Horvath", "Akif Akson", "2.48.00", "—"],
  [1931, "Young Turc", "Schnelley", "Mr. Yantes", "3.05.20", "—"],
  [1930, "Olgo", "N. Horvath", "İsmet İnönü", "2.44.00", "—"],
  [1929, "Cap Gris Nez", "Jimmy Clark", "Celal Bayar", "2.42.00", "—"],
  [1928, "Primerole", "Yula", "Atıf Esenbel", "2.45.00", "—"],
  [1927, "Neriman", "İhsan Atçı", "Ali Muhittin Hacı Bekir", "2.50.00", "—"]
];

const overrides = {
  2026: {
    story: "28 Haziran 2026’da koşulan 100. Gazi Koşusu’nu, Emrah Nalçakan'ın sahibi olduğu BAY NALÇAKAN, jokeyi Halis Karataş idaresinde 2.29.49'luk derecesiyle kazandı. Yarışlar tesadüfen kazanılmaz. Bay Nalçakan en iyi performansını tam doğru günde sergiledi. Halis Karataş ise neden tarihin en büyük jokeylerinden biri olarak görüldüğünü bir kez daha kanıtladı."
  },
  2025: {
    story: "29 Haziran 2025’te koşulan Gazi Koşusu’nu, VICTOIRE PISA (JPN) - SUZİ DIOMAND orijinli CUTHA, 30.000.000 TL ikramiyeyle kazandı."
  },
  2024: {
    story: "30 Haziran 2024’te koşulan Gazi Koşusu’nu, TOROK (IRE) - HAPPY VALENTINE orijinli DRAGON FLAME, 13.500.000 TL ikramiyeyle kazandı."
  },
  2023: {
    story: "25 Haziran 2023’te koşulan Gazi Koşusu’nu, APPROVE (IRE) - WAIMARIA (IRE) orijinli URFA ASLANI, 5.000.000 TL ikramiyeyle kazandı."
  },
  2022: {
    story: "26 Haziran 2022’de koşulan Gazi Koşusu’nu, NATIVE KHAN (FR) - FLEETING MIRAGE (USA) orijinli SECRET POWER, 2.500.000 TL ikramiyeyle kazandı."
  },
  2021: {
    story: "26 Haziran 2021’de koşulan Gazi Koşusu’nu, KING DAVID (USA) - THISBE orijinli BURGAS, 2.100.000 TL ikramiyeyle kazandı. Jokey Ahmet Çelik, 2015–2021 yılları arasında üst üste 7 yıl kazanarak derbi tarihinde kırılması güç inanılmaz bir seriye imza atmıştır."
  },
  2020: {
    story: "30 Ağustos 2020’de koşulan Gazi Koşusu’nu, VICTORY GALLOP (CAN) - SERAP GELİN orijinli CALL TO VICTORY, 1.750.000 TL ikramiyeyle kazandı. Geleneksel haziran takvimi, COVID-19 pandemisi nedeniyle ertelenerek yarışın 30 Ağustos Zafer Bayramı’nda koşulmasına yol açmıştır."
  },
  2019: {
    story: "30 Haziran 2019’da koşulan Gazi Koşusu’nu, TIZWAY (USA) - CUMULUS (GB) orijinli THE LAST ROMANCE, 1.650.000 TL ikramiyeyle kazandı."
  },
  2018: {
    story: "1 Temmuz 2018’de koşulan Gazi Koşusu’nu, SCREAM TO SCREAM (IRE) - VENEZUELLA orijinli HEP BERABER, 1.650.000 TL ikramiyeyle kazandı."
  },
  2017: {
    story: "25 Haziran 2017’de koşulan Gazi Koşusu’nu, TOROK (IRE) - EMMA orijinli PIANO SONATA, 1.500.000 TL ikramiyeyle kazandı."
  },
  2016: {
    story: "26 Haziran 2016’da koşulan Gazi Koşusu’nu, LUXOR - SETRYN orijinli GRAYSTORM, 1.350.000 TL ikramiyeyle kazandı."
  },
  2015: {
    story: "28 Haziran 2015’te koşulan Gazi Koşusu’nu, DIVINE LIGHT (JPN) - BUSİ orijinli RENK, 1.350.000 TL ikramiyeyle kazandı."
  },
  2014: {
    story: "29 Haziran 2014’te koşulan Gazi Koşusu’nu, WIN RIVER WIN (USA) - LOVELY BLAZE orijinli BLAZE TO WIN, 1.350.000 TL ikramiyeyle kazandı."
  },
  2013: {
    story: "30 Haziran 2013’te koşulan Gazi Koşusu’nu, DIVINE LIGHT (JPN) - SULTANİYE orijinli DIVINE HEART, 1.150.000 TL ikramiyeyle kazandı."
  },
  2012: {
    story: "24 Haziran 2012’de koşulan Gazi Koşusu’nu, NATIVE PROCIDA - FREEZONE orijinli MATADOR YAŞAR, 1.000.000 TL ikramiyeyle kazandı."
  },
  2011: {
    story: "26 Haziran 2011’de koşulan Gazi Koşusu’nu, RED BISHOP (USA) - BLACK SHADOW orijinli ANATOLY, 850.000 TL ikramiyeyle kazandı."
  },
  2010: {
    story: "27 Haziran 2010’da koşulan Gazi Koşusu’nu, UNACCOUNTED FOR (USA) - NAĞME orijinli MYSTICAL STORM, 750.000 TL ikramiyeyle kazandı."
  },
  2009: {
    story: "28 Haziran 2009’da koşulan Gazi Koşusu’nu, SRI PEKAN (USA) - SATILMIŞ orijinli MİRAMİS, 750.000 TL ikramiyeyle kazandı."
  },
  2008: {
    story: "29 Haziran 2008’de koşulan Gazi Koşusu’nu, RED BISHOP (USA) - WANGANUI RIVER (GB) orijinli PAN RIVER, 750.000 TL ikramiyeyle kazandı."
  },
  2007: {
    story: "24 Haziran 2007’de koşulan Gazi Koşusu’nu, BIN AJWAAD (IRE) - PANDORA (GER) orijinli INSPECTOR, 500.000 TL ikramiyeyle kazandı."
  },
  2006: {
    story: "25 Haziran 2006’da koşulan Gazi Koşusu’nu, RED BISHOP (USA) - DANDİNİ orijinli HIZEL BEYİ, 420.000 TL ikramiyeyle kazandı."
  },
  2005: {
    story: "26 Haziran 2005’te koşulan Gazi Koşusu’nu, EAGLE EYED (USA) - İMAN orijinli POPULAR DEMAND, 400.000 TL ikramiyeyle kazandı. Eliyeşil Ekürisi; Karayel, Hafız ve Popular Demand gibi efsanevi safkanlarıyla toplamda 13 zafer elde ederek Gazi Koşusu tarihinin en başarılı ekürisi olmuştur."
  },
  2004: {
    story: "26 Haziran 2004’te koşulan Gazi Koşusu’nu, DISTANT RELATIVE (IRE) - CINDY I orijinli YAVUZSTAR, 400.000 TL ikramiyeyle kazandı."
  },
  2003: {
    story: "29 Haziran 2003’te koşulan Gazi Koşusu’nu, RIFAPOUR (IRE) - LAIKIPIA (FR) orijinli SUFİ, 350.000 TL ikramiyeyle kazandı."
  },
  2002: {
    story: "30 Haziran 2002’de koşulan Gazi Koşusu’nu, SABREHILL (USA) - SARAH'S LOVE (GB) orijinli FERNANDO, 300.000 TL ikramiyeyle kazandı."
  },
  2001: {
    story: "24 Haziran 2001’de koşulan Gazi Koşusu’nu, BARNATO (USA) - VIOLENT GIRL orijinli GRAND EKINOKS, 250.000 TL ikramiyeyle kazandı. Grand Ekinoks, aynı yıl Erkek Tay Deneme ve Ankara Koşusu'nu da kazanarak milenyumun ilk, Türk yarışçılık tarihinin ise son Triple Crown (Üçlü Taç) şampiyonu olmuştur.",
    isLegend: true,
    legendTitle: "MİLYONLARIN SEVGİLİSİ",
    accentColor: "#ffaa00"
  },
  2000: {
    story: "25 Haziran 2000’de koşulan Gazi Koşusu’nu, GEORGE THOMAS - NİYAGARA orijinli CAPRICE, 200.000 TL ikramiyeyle kazandı. Caprice, elde ettiği 2.26.71'lik bitiriş derecesiyle Bold Pilot'ın tarihi rekoruna (2.26.22) en çok yaklaşan şampiyonlardan biridir."
  },
  1999: {
    story: "27 Haziran 1999’da koşulan Gazi Koşusu’nu, DILUM (USA) - HONEY CHURCH (USA) orijinli BARTROBEL, 120.000 TL ikramiyeyle kazandı."
  },
  1998: {
    story: "28 Haziran 1998’de koşulan Gazi Koşusu’nu, BACHELOR PARTY (IRE) - NASİBE I orijinli KAVRANHAN, 70.000 TL ikramiyeyle kazandı."
  },
  1997: {
    story: "29 Haziran 1997’de koşulan Gazi Koşusu’nu, COSSACK GUARD (USA) - BURNELLE (GB) orijinli FAIR TAIL, 25.000 TL ikramiyeyle kazandı."
  },
  1996: {
    story: "23 Haziran 1996’da koşulan Gazi Koşusu’nu, PERSIAN BOLD (IRE) - ROSA PALUMBO (GB) orijinli BOLD PILOT, 8.000 TL ikramiyeyle kazandı. Bold Pilot, 2.26.22'lik bitiriş derecesiyle 30 yıldır kırılamayan efsanevi rekorun sahibidir. Ayrıca Bold Pilot, aynı yıl Erkek Tay Deneme ve Ankara Koşusu'nu da kazanarak Triple Crown (Üçlü Taç) unvanını elde etmiştir.",
    isLegend: true,
    legendTitle: "KIRILMAZ REKOR",
    accentColor: "#ff4b4b"
  },
  1995: {
    story: "25 Haziran 1995’te koşulan Gazi Koşusu’nu, LOCKTON (GB) - TIGHT BOX (IRE) orijinli WELLDONE, 3.000 TL ikramiyeyle kazandı."
  },
  1994: {
    story: "26 Haziran 1994’te koşulan Gazi Koşusu’nu, ARSLAN - JEANNIE EARL (GB) orijinli AS JET, 1.100 TL ikramiyeyle kazandı."
  },
  1993: {
    story: "20 Haziran 1993’te koşulan Gazi Koşusu’nu, EFISIO (GB) - KEEP HOPING (FR) orijinli THE BEST, 750 TL ikramiyeyle kazandı. 1993 yılında The Best – I. Thunder Bold ikilisiyle Kurt ekürisi ilk iki sırayı alarak eküri birinciliği kazanmıştır."
  },
  1992: {
    story: "21 Haziran 1992’de koşulan Gazi Koşusu’nu, PLEVNE - VIENNESE WALTZ (GB) orijinli PRESTIGE, 550 TL ikramiyeyle kazandı."
  },
  1991: {
    story: "16 Haziran 1991’de koşulan Gazi Koşusu’nu, CASTLE RISING (GB) - SQUARE NOTE (GB) orijinli ABBAS, 500 TL ikramiyeyle kazandı. Jokey Mümin Çılgın, bu zaferiyle toplamda 9 Gazi zaferine ulaşarak Gazi Koşusu'nu en çok kazanan jokey unvanını elinde tutmaktadır."
  },
  1990: {
    story: "24 Haziran 1990’da koşulan Gazi Koşusu’nu, GODSWALK (USA) - KEEP SHINING (USA) orijinli GEORGE THOMAS, 250 TL ikramiyeyle kazandı. Yavrusu Caprice ile aynı kupayı kazanma gururunu yaşamıştır."
  },
  1989: {
    story: "18 Haziran 1989’da koşulan Gazi Koşusu’nu, EASTERN STAR - GOLD LEAF orijinli GOLDEN PRINCE, 100.000 TL ikramiyeyle kazandı."
  },
  1988: {
    story: "19 Haziran 1988’de koşulan Gazi Koşusu’nu, HIGH TOP (IRE) - AFTER IMAGE (USA) orijinli TOP IMAGE, 60.000 TL ikramiyeyle kazandı."
  },
  1987: {
    story: "21 Haziran 1987’de koşulan Gazi Koşusu’nu, RUNNING MILL (GB) - FLORIS orijinli MEHTER I, 36.000 TL ikramiyeyle kazandı."
  },
  1986: {
    story: "22 Haziran 1986’da koşulan Gazi Koşusu’nu, ROYAL SHIRAZ (GB) - LİNDA orijinli HAFIZ, 30.000 TL ikramiyeyle kazandı. 1986 yılında Hafız – Kapkara ikilisiyle Eliyeşil ekürisi ilk iki sırayı alarak eküri birinciliği kazanmıştır. Hafız, aynı yıl Erkek Tay Deneme ve Ankara Koşusu'nu da kazanarak Triple Crown (Üçlü Taç) şampiyonu olmuştur.",
    isLegend: true,
    legendTitle: "ÜÇLÜ TAÇ ŞAMPİYONU",
    accentColor: "#ffeaa7"
  },
  1985: {
    story: "7 Temmuz 1985’te koşulan Gazi Koşusu’nu, TÜNKUT - NOSANA (GB) orijinli UĞURTAY, 20.000 TL ikramiyeyle kazandı. Uğurtay, aynı yıl Erkek Tay Deneme ve Ankara Koşusu'nu da kazanarak Triple Crown (Üçlü Taç) sahibi olmuştur.",
    isLegend: true,
    legendTitle: "PİSTLERİN EFENDİSİ",
    accentColor: "#ff7675"
  },
  1984: {
    story: "17 Haziran 1984’te koşulan Gazi Koşusu’nu, KARAYEL - ARZU I orijinli CARTEGENA, 12.000 TL ikramiyeyle kazandı."
  },
  1983: {
    story: "19 Haziran 1983’te koşulan Gazi Koşusu’nu, KARAYEL - KARANARA orijinli SEREN I, 7.000 TL ikramiyeyle kazandı. Yavrusu Cartagena da Gazi Koşusu'nu kazanmıştır. Ayrıca Seren I, babası Karayel gibi Erkek Tay Deneme, Gazi Koşusu ve Ankara Koşusu'nu kazanarak Triple Crown (Üçlü Taç) unvanını elde etmiştir.",
    isLegend: true,
    legendTitle: "ÜÇLÜ TAÇ SAHİBİ",
    accentColor: "#00cec9"
  },
  1982: {
    story: "20 Haziran 1982’de koşulan Gazi Koşusu’nu, AKKOR - NOCES orijinli TORAMAN, 3.000 TL ikramiyeyle kazandı."
  },
  1981: {
    story: "28 Haziran 1981’de koşulan Gazi Koşusu’nu, CALABOOSE (GB) - SAİKA orijinli DERSİM, 1.500.000 TL ikramiyeyle kazandı."
  },
  1980: {
    story: "29 Haziran 1980’de koşulan Gazi Koşusu’nu, AVEROF (GB) - LEVANSWOOD (IRE) orijinli LEVANO, 1.000.000 TL ikramiyeyle kazandı. 1979'da Büyük Ankara Hipodromu'nun kapanmasının ardından, Gazi Koşusu bu yıldan itibaren kalıcı olarak İstanbul Veliefendi Hipodromu'nda düzenlenmeye başlanmıştır."
  },
  1979: {
    story: "24 Haziran 1979’da koşulan Gazi Koşusu’nu, GOLD ROD (GB) - JEANEXA (GB) orijinli DOKTOR SEFEROF, 560.000 TL ikramiyeyle kazandı."
  },
  1978: {
    story: "25 Haziran 1978’de koşulan Gazi Koşusu’nu, CLOSE HARMONY (GB) - BELLİNA orijinli CİHANGİR HARMONY, 420.000 TL ikramiyeyle kazandı."
  },
  1977: {
    story: "26 Haziran 1977’de koşulan Gazi Koşusu’nu, CALABOOSE (GB) - MY VALDINE orijinli VİDAR, 350.000 TL ikramiyeyle kazandı."
  },
  1976: {
    story: "13 Haziran 1976’da koşulan Gazi Koşusu’nu, PRINCE TUDOR (GB) - FRICASSE'E (GB) orijinli BUĞRA, 280.000 TL ikramiyeyle kazandı."
  },
  1975: {
    story: "15 Haziran 1975’te koşulan Gazi Koşusu’nu, CALABOOSE (GB) - AYHAN orijinli MAYİDE, 210.000 TL ikramiyeyle kazandı."
  },
  1974: {
    story: "9 Haziran 1974’te koşulan Gazi Koşusu’nu, OUR GUILE (GB) - BIG ROMANCE orijinli NADAS, 210.000 TL ikramiyeyle kazandı."
  },
  1973: {
    story: "10 Haziran 1973’te koşulan Gazi Koşusu’nu, PRINCE TUDOR (GB) - LİNDA orijinli KARAYEL, 210.000 TL ikramiyeyle kazandı. Yarış hayatı boyunca hiç geçilmeyen efsanevi safkan, aynı yıl Erkek Tay Deneme ve Ankara Koşusu'nu da kazanarak Triple Crown (Üçlü Taç) şampiyonu olmuştur.",
    isLegend: true,
    legendTitle: "GEÇİLMEZ EFSANE",
    accentColor: "#4f75ff"
  },
  1972: {
    story: "11 Haziran 1972’de koşulan Gazi Koşusu’nu, CİHANGİR (GB) - GREY RHYTHM (GB) orijinli AKKOR, 210.000 TL ikramiyeyle kazandı. Babası Cihangir; Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo ve Akkor ile birlikte toplamda 6 Gazi kazanan yavru veren efsanevi bir aygırdır. Akkor ayrıca yavrusu Toraman ile birlikte derbi tarihine geçmiştir."
  },
  1971: {
    story: "13 Haziran 1971’de koşulan Gazi Koşusu’nu, CİHANGİR (GB) - MIGHTY MO (GB) orijinli MINIMO, 175.000 TL ikramiyeyle kazandı. Babası Cihangir; Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo ve Akkor ile birlikte toplamda 6 Gazi kazanan yavru vererek derbi tarihinin en çok kazanan yavru veren aygırıdır. Minimo, bu tarihi zaferin ardından Ankara Koşusu'nu da kazanarak Triple Crown (Üçlü Taç) sahibi tek dişi tay (kısrak) olarak tarihe geçmiştir.",
    isLegend: true,
    legendTitle: "EFSANE KISRAK",
    accentColor: "#fd79a8"
  },
  1970: {
    story: "14 Haziran 1970’te koşulan Gazi Koşusu’nu, CAERLAVEROCK (GB) - ZEYNEP orijinli SAADETTİN, 105.000 TL ikramiyeyle kazandı. Bu yıldan itibaren kazananlara heykeltıraş Doç. Dr. Şadi Çalık'ın eseri olan Atatürk'ün at üzerindeki som gümüş heykeli verilmeye başlanmış ve bu heykeli ilk kez Sadettin'in sahibi Sadun Atığ almıştır. Ayrıca Sadettin, bu zaferiyle Türk yarışçılık tarihinin ilk Triple Crown (Üçlü Taç) şampiyonluğunu ilan etmiştir.",
    isLegend: true,
    legendTitle: "İLK ÜÇLÜ TAÇ",
    accentColor: "#a29bfe"
  },
  1969: {
    story: "Sedat Okumuş idaresindeki Palet, 1969 yılı Gazi Koşusu'nu kazanmıştır. Sedat Okumuş, bir önceki yıl Asuvan ile elde ettiği zaferin ardından Palet ile de kazanarak İstanbul Veliefendi döneminin başında üst üste iki Gazi zaferi elde eden ilk jokey olmuştur."
  },
  1968: {
    story: "Sedat Okumuş idaresindeki Asuvan, 1968 yılı Gazi Koşusu'nu kazanmıştır. Gazi Koşusu tarihinde ilk kez bu yıl İstanbul Veliefendi Hipodromu'nda koşulmuştur."
  },
  1967: {
    story: "Kazım Yıldız idaresindeki Selten, 1967 yılı Gazi Koşusu'nu kazanmıştır. Kazım Yıldız, bu koşudaki zaferiyle Gazi Koşusu'nu toplamda 7 kez kazanarak derbi tarihinin en başarılı jokeyleri arasına adını altın harflerle yazdırmıştır."
  },
  1966: {
    story: "Yaşar Atçı idaresindeki Pikehan, 1966 yılı Gazi Koşusu'nu kazanmıştır. Babası Cihangir; Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo ve Akkor ile birlikte toplamda 6 Gazi kazanan yavru veren efsanevi bir aygırdır."
  },
  1965: {
    story: "Mümin Çılgın idaresindeki Apaçi, 1965 yılı Gazi Koşusu'nu kazanmıştır. Jokey Mümin Çılgın, kariyeri boyunca toplam 9 Gazi zaferi elde ederek derbi tarihinin en çok kazanan jokeyi unvanını elinde tutmaktadır."
  },
  1964: {
    story: "Yaşar Atçı idaresindeki Kayarlı, 1964 yılı Gazi Koşusu'nu kazanmıştır. Babası Cihangir; Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo ve Akkor ile birlikte toplamda 6 Gazi kazanan yavru veren efsanevi bir aygırdır."
  },
  1963: {
    story: "Mehmet Emin Özdekli idaresindeki Melikşah, 1963 yılı Gazi Koşusu'nu kazanmıştır. Babası Cihangir; Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo ve Akkor ile birlikte toplamda 6 Gazi kazanan yavru veren efsanevi bir aygırdır."
  },
  1961: {
    story: "J. C. Majerus idaresindeki Atlıhan, 1961 yılı Gazi Koşusu'nu kazanmıştır. Babası Cihangir, 6 kez Gazi kazanan yavru (Atlıhan, Melikşah, Kayarlı, Pikehan, Minimo, Akkor) vererek derbi tarihine geçmiştir. Ayrıca Atlıhan, annesi Darling (1950) ile birlikte kendisi ve yavrusu Gazi kazanan efsanevi bir soy hattına sahiptir."
  },
  1960: {
    story: "Mümin Çılgın idaresindeki Helene de Troia, 1960 yılı Gazi Koşusu'nu kazanmıştır. Mümin Çılgın, Helene de Troia ile kazandığı bu yarışla derbi tarihindeki 9 zaferlik efsanevi rekorunun ilk adımlarını atmıştır."
  },
  1959: {
    story: "Kazım Yıldız idaresindeki Beau Manoir, 1959 yılı Gazi Koşusu'nu kazanarak Türk yarışçılık tarihinin en prestijli kupasını kaldırmıştır. Annesi Fleche d'Or; Beau Brummel (1954), La Fleche (1956) ve Beau Manoir (1959) yavrularıyla 3 kez Gazi şampiyonu vererek en başarılı kısrak olmuştur."
  },
  1958: {
    story: "Kazım Yıldız idaresindeki Icaros, 1958 yılı Gazi Koşusu'nu kazanmıştır. William Giraud ekürisi; 1958 (Icaros), 1959 (Beau Manoir) ve 1960 (Helene de Troia) yıllarında üst üste 3 kez kazanarak derbi tarihinin en güçlü eküri serilerinden birine imza atmıştır."
  },
  1956: {
    story: "İsmail Dinçer idaresindeki La Fleche, 1956 yılı Gazi Koşusu'nu kazanarak Türk yarışçılık tarihinin en prestijli kupasını kaldırmıştır. 1956'da La Fleche ve Cantatrice birinciliği paylaşarak tarihe geçmişlerdir. Ayrıca annesi Fleche d'Or; Beau Brummel (1954), La Fleche (1956) ve Beau Manoir (1959) olmak üzere 3 Gazi kazanan tay vermiştir."
  },
  1954: {
    story: "Reşat Mergin idaresindeki Beau Brummel, 1954 yılı Gazi Koşusu'nu kazanarak Türk yarışçılık tarihinin en prestijli kupasını kaldırmıştır. Annesi Fleche d'Or; Beau Brummel (1954), La Fleche (1956) ve Beau Manoir (1959) yavrularıyla 3 kez Gazi şampiyonu vererek en başarılı kısrak olmuştur."
  },
  1953: {
    story: "Ahmet Uslu idaresindeki Kusun, 1953 yılı Gazi Koşusu'nu kazanmıştır. Şadi Eliyeşil'in sahibi olduğu Kusun'un bu zaferi, derbi tarihini toplam 13 birincilikle kapatarak kırılması imkansız bir rekora imza atacak olan Eliyeşil Ekürisi'nin erken dönem başarılarındandır."
  },
  1952: {
    story: "Bahri Eröçbe idaresindeki Virago, 1952 yılı Gazi Koşusu'nu kazanmıştır. Merhum Özdemir Atman'ın sahibi olduğu Virago'nun bu zaferi, ilerleyen yıllarda TJK başkanlığı yapacak ve 1996 yılında efsanevi Bold Pilot ile derbi tarihinin en iyi derecesine imza atacak olan Atman ekürisinin köklü tarihini temsil eder."
  },
  1950: {
    story: "Ahmet Uslu idaresindeki Darling, 1950 yılı Gazi Koşusu'nu kazanarak Türk yarışçılık tarihinin en prestijli kupasını kaldırmıştır. Kendisi (1950) ve yavrusu Atlıhan (1961) Gazi şampiyonudur."
  },
  1945: {
    story: "Ş. Sokolay idaresindeki Fettan, 1945 yılı Gazi Koşusu'nu kazanmıştır. Türk atçılığının öncülerinden olan Ahmet Atman, Fettan'ın bu birinciliğiyle birlikte kariyerindeki 3. ve son Gazi zaferini elde etmiştir."
  },
  1944: {
    story: "Davut Akdı idaresindeki Toros, 1944 yılı Gazi Koşusu'nu kazanmıştır. Davut Akdı ve oğlu Süleyman Akdı, derbi tarihinde ikişer kez Gazi kazanarak tarihe geçen tek baba-oğul jokey ikilisidir."
  },
  1938: {
    story: "N. Horvath idaresindeki Romance, 1938 yılı Gazi Koşusu'nu kazanmıştır. Bu önemli yarış, Atatürk'ün vefat ettiği yıl olması dolayısıyla derbi tarihinde sadece 1938 yılında 'Atatürk Koşusu' adı altında düzenlenmiştir."
  },
  1936: {
    story: "Paul idaresindeki Şilem, 1936 yılı Gazi Koşusu'nu kazanmıştır. Atatürk'ün emriyle İtalyan mimar Paolo Vietti Violi'ye planları çizdirilen Büyük Ankara Hipodromu'nun açılmasıyla, Gazi Koşusu bu yıldan itibaren yeni hipodromda koşulmaya başlanmıştır."
  },
  1932: {
    story: "N. Horvath idaresindeki Lale, 1932 yılı Gazi Koşusu'nu kazanmıştır. 1932'den itibaren yarışmaya sınırlama getirilerek yalnızca 3 yaşlı yerli İngiliz taylarının katılımına izin verilmiş ve koşu mesafesi de 2000 metreden 2400 metreye çıkarılmıştır."
  },
  1930: {
    story: "N. Horvath idaresindeki Olgo, 1930 yılı Gazi Koşusu'nu kazanmıştır. Türkiye Cumhuriyeti'nin kurucu kadrolarından İsmet İnönü, bu önemli koşuyu kendi safkanıyla kazanarak derbi tarihine adını yazdırmıştır."
  },
  1929: {
    story: "Jimmy Clark idaresindeki Cap Gris Nez, 1929 yılı Gazi Koşusu'nu kazanmıştır. Gazi Koşusu'nun erken döneminde devlet adamlarının ilgisi büyüktü; Cap Gris Nez, Türkiye Cumhuriyeti'nin kurucu kadrolarından ve gelecekteki cumhurbaşkanı Celal Bayar'ın (Galip Bey) safkanı olarak bu kupayı kazanmıştır. Ayrıca yavruları Yılmazkaya ve efsanevi Karayel de Gazi şampiyonudur."
  },
  1927: {
    story: "Mustafa Kemal Atatürk'ün teşvikiyle düzenlenen ilk Gazi Koşusu'nun galibidir. 10 Haziran 1927'de Ankara'da 3 ve yukarı yaşlı İngiliz atlarına mahsus düzenlenen bu ilk yarışı Ali Muhiddin Hacıbekir'in sahibi olduğu Neriman, jokeyi İhsan Atçı ile kazanmış; koşuyu Atatürk ile İsmet İnönü birlikte izlemişlerdir.",
    isLegend: true,
    legendTitle: "İLK ŞAMPİYON",
    accentColor: "#d4af37"
  }
};

const englishYears = [2020, 2017, 2014, 2013, 2010, 2008, 2001, 2000, 1997, 1996, 1992, 1989, 1971, 1962, 1960, 1959, 1957, 1952, 1951, 1950, 1949, 1929, 1928];

const tjkUrls = {
  2025: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.2025+00%3A00%3A00&0=1#218277",
  2024: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=30.06.2024+00%3A00%3A00&0=1#210691",
  2023: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.2023+00%3A00%3A00&0=1#203527",
  2022: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2022+00%3A00%3A00&0=1#194245",
  2021: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2021+00%3A00%3A00&0=1#185994",
  2020: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=30.08.2020+00%3A00%3A00&0=1#178091",
  2019: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=30.06.2019+00%3A00%3A00&0=1#165430",
  2018: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=01.07.2018+00%3A00%3A00&0=1#138987",
  2017: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.2017+00%3A00%3A00&0=1#110739",
  2016: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2016+00%3A00%3A00&0=1#93032",
  2015: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=28.06.2015+00%3A00%3A00&0=1#86713",
  2014: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.2014+00%3A00%3A00&0=1#81059",
  2013: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=30.06.2013+00%3A00%3A00&0=1#75899",
  2012: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=24.06.2012+00%3A00%3A00&0=1#53218",
  2011: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2011+00%3A00%3A00&0=1#48698",
  2010: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=27.06.2010+00%3A00%3A00&0=1#44465",
  2009: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=28.06.2009+00%3A00%3A00&0=1#40101",
  2008: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.2008+00%3A00%3A00&0=1#35549",
  2007: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=24.06.2007+00%3A00%3A00&0=1#31371",
  2006: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.2006+00%3A00%3A00&0=1#27681",
  2005: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2005+00%3A00%3A00&0=1#23887",
  2004: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.2004+00%3A00%3A00&0=1#13735",
  2003: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.2003+00%3A00%3A00&0=1#12974",
  2002: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=30.06.2002+00%3A00%3A00&0=1#12246",
  2001: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=24.06.2001+00%3A00%3A00&0=1#11492",
  2000: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.2000+00%3A00%3A00&0=1#10721",
  1999: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=27.06.1999+00%3A00%3A00&0=1#9983",
  1998: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=28.06.1998+00%3A00%3A00&0=1#9262",
  1997: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.1997+00%3A00%3A00&0=1#8461",
  1996: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=23.06.1996+00%3A00%3A00&0=1#7759",
  1995: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.1995+00%3A00%3A00&0=1#70562",
  1994: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.1994+00%3A00%3A00&0=1#68876",
  1993: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=20.06.1993+00%3A00%3A00&0=1#67326",
  1992: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=21.06.1992+00%3A00%3A00&0=1#65911",
  1991: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=16.06.1991+00%3A00%3A00&0=1#64518",
  1990: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=24.06.1990+00%3A00%3A00&0=1#63174",
  1989: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=18.06.1989+00%3A00%3A00&0=1#92607",
  1988: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=19.06.1988+00%3A00%3A00&0=1#98365",
  1987: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=21.06.1987+00%3A00%3A00&0=1#124783",
  1986: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=22.06.1986+00%3A00%3A00&0=1#154781",
  1985: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=07.07.1985+00%3A00%3A00&0=1#147729",
  1984: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=17.06.1984+00%3A00%3A00&0=1#150218",
  1983: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=19.06.1983+00%3A00%3A00&0=1#145172",
  1982: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=20.06.1982+00%3A00%3A00&0=1#139144",
  1981: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=28.06.1981+00%3A00%3A00&0=1#159079",
  1980: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=29.06.1980+00%3A00%3A00&0=1#144426",
  1979: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=24.06.1979+00%3A00%3A00&0=1#153706",
  1978: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=25.06.1978+00%3A00%3A00&0=1#162743",
  1977: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=26.06.1977+00%3A00%3A00&0=1#157207",
  1976: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=13.06.1976+00%3A00%3A00&0=1#158984",
  1975: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=15.06.1975+00%3A00%3A00&0=1#146903",
  1974: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=09.06.1974+00%3A00%3A00&0=1#147394",
  1973: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=10.06.1973+00%3A00%3A00&0=1#170512",
  1972: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=11.06.1972+00%3A00%3A00&0=1#161056",
  1971: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=13.06.1971+00%3A00%3A00&0=1#176490",
  1970: "https://www.tjk.org/TR/map/Info/Page/GunlukYarisSonuclari?QueryParameter_Tarih=14.06.1970+00%3A00%3A00&0=1#163092"
};

const placementsData = {
  2025: ["Handsome King", "Special Man"],
  2024: ["Zizka", "Borrego"],
  2023: ["Qualizto", "Chaika"],
  2022: ["Mucize Kız", "Sigoş"],
  2021: ["Real Runner", "Megaloman"],
  2020: ["Lord of Game", "Kingsman"],
  2019: ["Kuzey Kafkasyalı", "Hürat"],
  2018: ["Distant Shining", "Mister Görkem"],
  2017: ["Pershing", "Finesse"],
  2016: ["Temsil", "Cooger"],
  2015: ["Tatvan İncisi", "Güngör Baba"],
  2014: ["Sozi Gold", "Enyalios"],
  2013: ["Çakal Carlos", "Celeritas"],
  2012: ["Başkan Nexia", "Cihanım"],
  2011: ["Hannbeş", "Little Gangster"],
  2010: ["Akdeniz Ateşi", "Smerç"],
  2009: ["Çakılhan", "Chi"],
  2008: ["Nihalim", "Pontiac"],
  2007: ["Arsenic", "Salvatore"],
  2006: ["Annosh", "Bors"],
  2005: ["Mahalle Çocuğu", "Caribou"],
  2004: ["Kaneko", "Sabırlı"],
  2003: ["Keremkoç", "Eylül Fırtınası"],
  2002: ["Ultramar", "Klubnika"],
  2001: ["Red Neck", "Cannon"],
  2000: ["Sheer Honor", "İsmethan"],
  1999: ["Talaria", "Mighty Moor"],
  1998: ["Rüzgarın Kızı", "Champs"],
  1997: ["Sam Holme", "Sun Speed"],
  1996: ["Damista", "Ramadan"],
  1995: ["Sertkaya", "Jery Lewis"],
  1994: ["Lyra", "Dartino"],
  1993: ["Thunder Bolt 1", "Golden Hawk"],
  1992: ["Lala", "Altınözü"],
  1991: ["Native Procida", "Günışık"],
  1990: ["Gapano", "Cartekitt"],
  1989: ["Devir", "Tender Cock"],
  1988: ["Aristocrat", "Rolls Royce"],
  1987: ["Golden Apple", "Night Fever"],
  1986: ["Kapkara", "Juarez"],
  1985: ["Excalibur", "Aslanım"],
  1984: ["Esperanto", "Hakan 1"],
  1983: ["Armağan 2", "Day Star"],
  1982: ["Serhan", "Gahubigah"],
  1981: ["Yavça", "Arkadaş"],
  1980: ["Amour", "Eastern Star"],
  1979: ["Last King", "Öznur"],
  1978: ["Riberta", "Fatih"],
  1977: ["Big-Ben", "Pekerol"],
  1976: ["Calvados", "Lütfü"],
  1975: ["Binboğa", "Belle Otera"],
  1974: ["Ay Tudor", "Boy Sie"],
  1973: ["Ophelia 1", "Egemen"],
  1972: ["Tuğrulbey", "Quick Judgement"],
  1971: ["On The Rocks", "Aynur"],
  1970: ["Golden Sun", "Kılıçarslan"],
  1969: ["Martini", "Rocky Mountain"],
  1968: ["Ringo", "Melikgazi"],
  1967: ["Eden Rock", "Noces"],
  1966: ["Ayizi", "Viceroy"],
  1965: ["Superjet", "Sevin"],
  1964: ["Mine 1", "Golden Dream"],
  1963: ["L'Aiglon", "Gücüm"],
  1962: ["Fire Work", "Beau Regard"],
  1961: ["Kamikaza", "Gülseren"],
  1960: ["Han", "Telemaque"],
  1959: ["Fanler", "Silver Star"],
  1958: ["Scarlette", "Özden"],
  1957: ["Emel", "Şahlevent"],
  1956: ["Cantarice", "Toprak"],
  1955: ["Polomba", "Asalet"],
  1954: ["Samson", "La Karioka"],
  1953: ["Gülşen", "Muazzez"],
  1952: ["Uğur", "Roi Soleil"],
  1951: ["Apache", "Cebel"],
  1950: ["Dorr-Q", "Anış"],
  1949: ["Modaly", "Citedel"],
  1948: ["Yiğit", "Gözdem"],
  1947: ["Hoppa", "Hülya"],
  1946: ["Bürücek", "Levent"],
  1945: ["Karatepe", "Gelincik"],
  1944: ["Savaş", "Sürtük"],
  1943: ["Destegül", "İz"],
  1942: ["Demet", "Heybeli"],
  1941: ["Yetiş", "Yosma"],
  1940: ["Miss", "Thais"],
  1939: ["Yatağan", "Batray"],
  1938: ["Özdemir", "Şıpka"],
  1937: ["Dafya", "Girgin"],
  1936: ["Önüsar", "Yörük"],
  1935: ["Erol", "Doğan"],
  1934: ["Conk", "Çelenk"],
  1933: ["Türkan", "Güler"],
  1932: ["Gözdem", "Şenkız"],
  1931: ["Frig", "Drocourt"],
  1930: ["Andronicus", "Stradivardius"],
  1929: ["Olgo", "Bananez"],
  1928: ["Nona", "Freudinau"],
  1927: ["Fama", "Bollandist"]
};

function getFormattedHorseName(name, year) {
  if (englishYears.includes(Number(year))) {
    return name.toLocaleUpperCase('en-US');
  }
  return name.toLocaleUpperCase('tr-TR');
}

export const coatData = {
  2025: { code: "d", name: "Doru" },
  2024: { code: "d", name: "Doru" },
  2023: { code: "d", name: "Doru" },
  2022: { code: "k", name: "Kır" },
  2021: { code: "d", name: "Doru" },
  2020: { code: "d", name: "Doru" },
  2019: { code: "d", name: "Doru" },
  2018: { code: "d", name: "Doru" },
  2017: { code: "d", name: "Doru" },
  2016: { code: "k", name: "Kır" },
  2015: { code: "a", name: "Al" },
  2014: { code: "d", name: "Doru" },
  2013: { code: "d", name: "Doru" },
  2012: { code: "d", name: "Doru" },
  2011: { code: "d", name: "Doru" },
  2010: { code: "d", name: "Doru" },
  2009: { code: "d", name: "Doru" },
  2008: { code: "d", name: "Doru" },
  2007: { code: "d", name: "Doru" },
  2006: { code: "a", name: "Al" },
  2005: { code: "d", name: "Doru" },
  2004: { code: "d", name: "Doru" },
  2003: { code: "a", name: "Al" },
  2002: { code: "a", name: "Al" },
  2001: { code: "d", name: "Doru" },
  2000: { code: "d", name: "Doru" },
  1999: { code: "d", name: "Doru" },
  1998: { code: "a", name: "Al" },
  1997: { code: "d", name: "Doru" },
  1996: { code: "d", name: "Doru" },
  1995: { code: "a", name: "Al" },
  1994: { code: "a", name: "Al" },
  1993: { code: "a", name: "Al" },
  1992: { code: "d", name: "Doru" },
  1991: { code: "d", name: "Doru" },
  1990: { code: "d", name: "Doru" },
  1989: { code: "d", name: "Doru" },
  1988: { code: "d", name: "Doru" },
  1987: { code: "d", name: "Doru" },
  1986: { code: "d", name: "Doru" },
  1985: { code: "d", name: "Doru" },
  1984: { code: "d", name: "Doru" },
  1983: { code: "d", name: "Doru" },
  1982: { code: "d", name: "Doru" },
  1981: { code: "d", name: "Doru" },
  1980: { code: "d", name: "Doru" },
  1979: { code: "a", name: "Al" },
  1978: { code: "d", name: "Doru" },
  1977: { code: "d", name: "Doru" },
  1976: { code: "d", name: "Doru" },
  1975: { code: "a", name: "Al" },
  1974: { code: "a", name: "Al" },
  1973: { code: "d", name: "Doru" },
  1972: { code: "d", name: "Doru" },
  1971: { code: "d", name: "Doru" },
  1970: { code: "d", name: "Doru" }
};

const pressClippingMap = {
  1963: "15.06.1963.jpg",
  1965: "13.06.1965.jpg",
  1968: "17.06.1968.jpg",
  1969: "16.06.1969.jpg",
  1970: "14.06.1970.jpg",
  1971: "13.06.1971.jpg",
  1972: "10.06.1972.jpg",
  1973: "11.06.1973.jpg",
  1974: "10.06.1974.jpg",
  1975: "15.06.1975.jpg",
  1976: "14.06.1976.jpg",
  1977: "27.06.1977.jpg",
  1978: "25.06.1978.jpg",
  1979: "25.06.1979.jpg",
  1980: "30.06.1980.jpg",
  1981: "29.06.1981.jpg",
  1982: "22.06.1982.jpg",
  1983: "20.06.1983.jpg",
  1984: "17.06.1984.jpg",
  1985: "08.07.1985.jpg",
  1986: "23.06.1986.jpg",
  1987: "21.06.1987.jpg",
  1988: "20.06.1988.jpg",
  1989: "19.06.1989.jpg",
  1990: "25.06.1990.jpg",
  1991: "18.06.1991.jpg",
  1992: "22.06.1992.jpg",
  1993: "21.06.1993.jpg",
  1994: "27.06.1994.jpg",
  1995: "25.06.1995.jpg",
  1996: "24.06.1996.jpg",
  1997: "30.06.1997.jpg",
  1998: "29.06.1998.jpg",
  1999: "28.06.1999.jpg",
  2000: "26.06.2000.jpg",
  2002: "30.06.2002.jpg",
  2003: "29.06.2003.jpg",
  2004: "27.06.2004.jpg",
  2005: "26.06.2005.jpg",
  2006: "25.06.2006.jpg",
  2007: "25.06.2007.jpg"
};

// Map raw winners into structured objects, merging overrides
export const gaziWinners = rawWinners.map(([year, horseName, jockey, owner, time, video]) => {
  const yearNum = Number(year);
  let city = "Ankara";
  if (yearNum === 1968 || yearNum >= 1980) {
    city = "İstanbul";
  }

  const placements = placementsData[yearNum];
  const coat = coatData[yearNum];

  const base = {
    year,
    horseName,
    horseNameUpper: getFormattedHorseName(horseName, year),
    jockey,
    time: time || "Kayıt Yok",
    owner: owner || "Tarih Arşivi",
    video: video && video !== "—" ? video : null,
    tjkUrl: tjkUrls[year] || null,
    pressClipping: pressClippingMap[yearNum] || null,
    city,
    story: `${jockey} idaresindeki ${horseName}, ${year} yılı Gazi Koşusu'nu kazanarak Türk yarışçılık tarihinin en prestijli kupasını kaldırmıştır.`,
    isLegend: false,
    secondPlace: placements ? placements[0] : null,
    thirdPlace: placements ? placements[1] : null,
    coatCode: coat ? coat.code : null,
    coatName: coat ? coat.name : null
  };

  if (overrides[year]) {
    return { ...base, ...overrides[year] };
  }

  return base;
});

export const statistics = {
  totalRaces: 99,
  recordHolder: "2.26.22 (Bold Pilot)",
  mostWinsJockey: "Mümin Çılgın (9)",
  consecutiveWinsJockey: "Ahmet Çelik (7/7)",
  mostWinsOwner: "Eliyeşil Ekürisi (13)",
  firstWinner: "Neriman (1927)"
};

export const prizeGoldData = {
  2026: { prize: 100000000, gold: 2439 },
  2025: { prize: 30000000, gold: 1079 },
  2024: { prize: 13500000, gold: 835 },
  2023: { prize: 5000000, gold: 473 },
  2022: { prize: 2500000, gold: 386 },
  2021: { prize: 2100000, gold: 635 },
  2020: { prize: 1750000, gold: 568 },
  2019: { prize: 1650000, gold: 983 },
  2018: { prize: 1650000, gold: 1349 },
  2017: { prize: 1500000, gold: 1621 },
  2016: { prize: 1350000, gold: 1634 },
  2015: { prize: 1350000, gold: 2022 },
  2014: { prize: 1350000, gold: 2295 },
  2013: { prize: 1150000, gold: 2289 },
  2012: { prize: 1000000, gold: 1663 },
  2011: { prize: 850000, gold: 1628 },
  2010: { prize: 750000, gold: 1801 },
  2009: { prize: 750000, gold: 2467 },
  2008: { prize: 750000, gold: 3152 },
  2007: { prize: 500000, gold: 2802 },
  2006: { prize: 420000, gold: 2050 },
  2005: { prize: 400000, gold: 3185 },
  2004: { prize: 400000, gold: 3117 },
  2003: { prize: 350000, gold: 3365 },
  2002: { prize: 300000, gold: 2862 },
  2001: { prize: 250000, gold: 3316 },
  2000: { prize: 200000, gold: 5294 },
  1999: { prize: 120000, gold: 5175 },
  1998: { prize: 70000, gold: 4212 },
  1997: { prize: 25000, gold: 2370 },
  1996: { prize: 8000, gold: 1201 },
  1995: { prize: 3000, gold: 831 },
  1994: { prize: 1100, gold: 418 },
  1993: { prize: 750, gold: 896 },
  1992: { prize: 550, gold: 1091 },
  1991: { prize: 500, gold: 1506 },
  1990: { prize: 250, gold: 1257 }
};
